<template>
  <div v-if="isVisible">
    <div
      class="property-indicator"
      :class="{
        'property-indicator--alt-pos': useAlternateIndicatorPosition,
        'property-indicator--rtl': lang.rtl
      }"
    >
      <div :dir="lang.rtl ? 'rtl' : 'ltr'">{{ countAvailable }} - {{ labels.available[lang.code] }}</div>
      <div :dir="lang.rtl ? 'rtl' : 'ltr'">{{ countOnHold }} - {{ labels.reserved[lang.code] }}</div>
      <div :dir="lang.rtl ? 'rtl' : 'ltr'">{{ countSold }} - {{ labels.sold[lang.code] }}</div>
      <div :dir="lang.rtl ? 'rtl' : 'ltr'">{{ countBlocked }} - {{ labels.blocked[lang.code] }}</div>
      <AvailabilityMarker status="Available" :x="lang.rtl ? 165 : -55" :y="7"></AvailabilityMarker>
      <AvailabilityMarker status="On Hold" :x="lang.rtl ? 165 : -55" :y="64"></AvailabilityMarker>
      <AvailabilityMarker status="Sold" :x="lang.rtl ? 165 : -55" :y="120"></AvailabilityMarker>
      <AvailabilityMarker status="Blocked" :x="lang.rtl ? 165 : -55" :y="176"></AvailabilityMarker>
    </div>
  </div>
</template>
<script>
import AvailabilityMarker from './AvailabilityMarker.vue';

export default {
  components: {
    AvailabilityMarker
  },

  data() {
    return {
      labels: {
        available: { en: 'Available', ar: 'متاحة' },
        reserved: { en: 'Reserved', ar: 'محجوزة' },
        sold: { en: 'Sold', ar: 'مباعة' },
        blocked: { en: 'Blocked', ar: 'محجوبة' },
      }
    }
  },

  computed: {
    lang() {
      return this.$store.getters.language  
    },
    
    countAvailable () {
      return this.subsection.properties.filter(property => property.status === 'Available').length
    },

    countOnHold () {
      return this.subsection.properties.filter(property => property.status === 'On Hold').length
    },

    countBlocked () {
      return this.subsection.properties.filter(property => (property.status === 'Management Blocked' || property.status === 'Blocked')).length
    },

    countSold () {
      return this.subsection.properties.filter(property => property.status === 'Sold').length
    },

    isVisible () {
      return (
         this.subsection && 
         this.subsectionChildType === 'property'
      )
    },

    subsection () {
      return this.$store.getters['property/activeSubsection']
    },

    subsectionChildType () {
      if (!this.subsection) return null
      if (this.subsection.subsections && this.subsection.subsections.length) {
        return 'subsection'
      } else {
        return 'property'
      }
    },  
    
    useAlternateIndicatorPosition () {
      return this.subsection._id === '60519bb09106ce12d5a63887'
    }    
  }
}
</script>
<style lang="scss">
.property-indicator {
  pointer-events: none;
  position: absolute;
  bottom: 13rem;
  left: 2rem;
  background-color: rgba(#0e1938, 0.85);
  height: 14rem;
  padding: 1rem;
  font-size: 1.4rem;
  width: 15rem;

  &--alt-pos {
    bottom: auto;
    top: 2rem;
  }

  .availability-marker {
    transform: scale(0.7);
  }

  > div {
    line-height: 2;
    font-weight: 200;
    margin-left: 2.5rem;
  }

  &--rtl > div {
    margin-right: 2.5rem;
  }
}
</style>